(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bpets-bestsellers-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBestsellers(root) {
      if (!root || root.dataset.bpetsInit === 'true') return;
      root.dataset.bpetsInit = 'true';

      var tabs = root.querySelectorAll('[role="tab"]');
      var panels = root.querySelectorAll('[role="tabpanel"]');

      function updateNavState(panel) {
        var track = panel.querySelector('[data-track]');
        var prev = panel.querySelector('[data-nav-prev]');
        var next = panel.querySelector('[data-nav-next]');
        if (!track) return;
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      }

      function getScrollAmount(track) {
        var firstCard = track.querySelector('.bpets-card');
        if (!firstCard) return 300;
        var styles = window.getComputedStyle(track);
        var gap = parseInt(styles.columnGap || styles.gap, 10) || 18;
        return (firstCard.offsetWidth + gap) * 2;
      }

      // ---- Carga diferida de los paneles ocultos -------------------------------
      // El HTML solo trae el panel visible. Los demas llegan por el Section Rendering API.
      function alturaDeReferencia() {
        var lleno = root.querySelector('[data-track]:not([data-lazy-collection])');
        return lleno && lleno.offsetHeight ? lleno.offsetHeight : 0;
      }

      function ensureLoaded(panel) {
        if (!panel) return;
        var track = panel.querySelector('[data-track]');
        if (!track) return;
        var handle = track.getAttribute('data-lazy-collection');
        if (!handle) return;
        if (track.dataset.lazyState === 'done' || track.dataset.lazyState === 'loading') return;

        track.dataset.lazyState = 'loading';
        var alto = alturaDeReferencia();
        if (alto) track.style.minHeight = alto + 'px';
        var max = parseInt(track.getAttribute('data-lazy-max'), 10) || 10;

        // La seccion pagina de a POR_PAGINA. Se piden solo las paginas que este tab usa:
        // 5 -> 1 peticion, 10 -> 2, 20 -> 4. Nada de descargar tarjetas que no se muestran.
        var POR_PAGINA = 5;
        var paginas = [];
        for (var n = 1; n <= Math.ceil(max / POR_PAGINA); n++) {
          paginas.push(n);
        }

        Promise.all(paginas.map(function (n) {
          return fetch('/collections/' + handle + '?section_id=api-bpets-tab-cards&page=' + n, {
            credentials: 'same-origin'
          }).then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.text();
          });
        }))
          .then(function (trozos) {
            var html = trozos.join('');
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var cards = doc.querySelectorAll('.bpets-card');
            if (!cards.length) throw new Error('sin tarjetas');
            var frag = document.createDocumentFragment();
            for (var i = 0; i < cards.length && i < max; i++) {
              frag.appendChild(document.importNode(cards[i], true));
            }
            track.innerHTML = '';
            track.appendChild(frag);
            track.dataset.lazyState = 'done';
            track.style.minHeight = '';
            if (typeof window.bpetsInitCarousels === 'function') { window.bpetsInitCarousels(track); }
            if (typeof window.bpetsUpdateShipping === 'function') { window.bpetsUpdateShipping(track); }
            updateNavState(panel);
          })
          .catch(function () {
            // Si algo falla, el tab no queda vacio: se ofrece la coleccion completa.
            track.dataset.lazyState = '';
            track.style.minHeight = '';
            if (!track.querySelector('.bpets-card')) {
              track.innerHTML = '<a class="bpets-bestsellers__fallback" href="/collections/' +
                handle + '">Ver todos los productos de esta categoria</a>';
            }
          });
      }

      function panelDe(tab) {
        return panels[parseInt(tab.dataset.tabIndex, 10)];
      }

      tabs.forEach(function (tab) {
        // Se adelanta al clic: apuntar el tab ya dispara la carga.
        tab.addEventListener('mouseenter', function () { ensureLoaded(panelDe(tab)); });
        tab.addEventListener('touchstart', function () { ensureLoaded(panelDe(tab)); }, { passive: true });
        tab.addEventListener('focus', function () { ensureLoaded(panelDe(tab)); });
      });

      // Los tabs ocultos ya NO se precargan solos al quedar ociosa la pagina: sumaban
      // 10 tarjetas al DOM y trabajo en el hilo principal (INP). Cargan al apuntar,
      // tocar o enfocar el tab, que es suficiente para que el clic se sienta inmediato.

      // Tab switching
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var index = parseInt(tab.dataset.tabIndex, 10);

          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('hidden', '');
          });

          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          var activePanel = panels[index];
          if (activePanel) {
            activePanel.classList.add('is-active');
            activePanel.removeAttribute('hidden');
            ensureLoaded(activePanel);
            var track = activePanel.querySelector('[data-track]');
            if (track) {
              track.scrollLeft = 0;
              updateNavState(activePanel);
            }
          }
        });
      });

      // Nav arrows + scroll state per panel
      panels.forEach(function (panel) {
        var track = panel.querySelector('[data-track]');
        var prev = panel.querySelector('[data-nav-prev]');
        var next = panel.querySelector('[data-nav-next]');
        if (!track) return;

        if (prev) {
          prev.addEventListener('click', function () {
            track.scrollBy({ left: -getScrollAmount(track), behavior: 'smooth' });
          });
        }
        if (next) {
          next.addEventListener('click', function () {
            track.scrollBy({ left: getScrollAmount(track), behavior: 'smooth' });
          });
        }

        track.addEventListener('scroll', function () {
          updateNavState(panel);
        }, { passive: true });

        updateNavState(panel);
      });
    }

    function initAll(context) {
      var root = context || document;
      root.querySelectorAll('[data-bpets-bestsellers]').forEach(initBestsellers);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bpets-related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (!root || root.dataset.bpetsCarouselInit === 'true') return;
      root.dataset.bpetsCarouselInit = 'true';

      var track = root.querySelector('[data-track]');
      var prev = root.querySelector('[data-nav-prev]');
      var next = root.querySelector('[data-nav-next]');
      if (!track) return;

      function getScrollAmount() {
        var firstCard = track.querySelector('.bpets-card');
        if (!firstCard) return 300;
        var styles = window.getComputedStyle(track);
        var gap = parseInt(styles.columnGap || styles.gap, 10) || 18;
        return (firstCard.offsetWidth + gap) * 2;
      }

      function updateNavState() {
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', function () {
        updateNavState();
      }, { passive: true });

      updateNavState();
    }

    function setupRelated(root) {
      if (!root) return;
      var track = root.querySelector('[data-track]');
      if (!track) return;

      var url = root.dataset.recommendationsUrl;

      // Sin URL: conservar la capa server-side (coleccion) y solo activar el carrusel.
      if (!url) {
        initCarousel(root);
        return;
      }

      // Pedir las recomendaciones NATIVAS de Shopify. Si llegan productos reales,
      // reemplazan la capa server-side. Si falla o no hay, se conserva lo server-side.
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var freshTrack = doc.querySelector('[data-bpets-related] [data-track]');
          if (
            freshTrack &&
            freshTrack.innerHTML.trim().length &&
            !freshTrack.querySelector('.bpets-card--placeholder')
          ) {
            // Limpiar parametros de tracking (?pr_prod_strat=...) que Shopify
            // incrusta en los links de recomendaciones. Dejar solo la URL canonica.
            freshTrack.querySelectorAll('a[href*="?"]').forEach(function (a) {
              a.setAttribute('href', a.getAttribute('href').split('?')[0]);
            });
            track.innerHTML = freshTrack.innerHTML;
          }
          if (window.bpetsUpdateShipping) window.bpetsUpdateShipping(root);
          if (window.bpetsInitCarousels) window.bpetsInitCarousels(root);
          initCarousel(root);
        })
        .catch(function () {
          initCarousel(root);
        });
    }

    function initAll(context) {
      var root = context || document;
      root.querySelectorAll('[data-bpets-related]').forEach(setupRelated);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
